import r from "../managers/braze-instance.js";
export function subscribeToSdkAuthenticationFailures(i) {
  var n;
  if (r.rr())
    return null === (n = r.Sr()) || void 0 === n
      ? void 0
      : n.subscribeToSdkAuthenticationFailures(i);
}
